import { writable } from 'svelte/store'
import { DASHBOARD_ROUTES } from './routesLinks'

export const ROUTES = {
  clientPortalUrl: import.meta.env.VITE_CLIENT_PORTAL_URL || '/',
  benchmark360: import.meta.env.VITE_BENCHMARK_360 || '/',
  homeDashboard: '/',
  DASHBOARD_ROUTES,
}

export const currentRoute = writable('/')
